import { render, staticRenderFns } from "./glyxxxg.vue?vue&type=template&id=4ff16b38&scoped=true&"
import script from "./glyxxxg.vue?vue&type=script&lang=js&"
export * from "./glyxxxg.vue?vue&type=script&lang=js&"
import style0 from "./glyxxxg.vue?vue&type=style&index=0&id=4ff16b38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff16b38",
  null
  
)

export default component.exports